/**
 * Trust the browser's play promise: it resolves when playback starts. Bound a
 * pending start and support cancellation, but never reload or retry media here.
 * Recovery belongs to the next Play, which owns a fresh attempt.
 *
 * @param {HTMLAudioElement} player
 * @param {AbortSignal} signal
 * @param {number} [timeoutMs]
 * @returns {Promise<void>}
 */
export function playAudio(player, signal, timeoutMs = 10000) {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => fail(new Error("Text-to-speech audio did not begin playing")), timeoutMs);
    const cancelled = () => fail(signal.reason);
    const failed = () => {
      if (player.error) fail(new Error(player.error.message || "Audio playback failed"));
    };
    function cleanup() {
      clearTimeout(timeout);
      signal.removeEventListener("abort", cancelled);
      player.removeEventListener("error", failed);
    }
    function fail(error) { cleanup(); reject(error); }
    function succeed() { cleanup(); resolve(); }
    signal.addEventListener("abort", cancelled, {once: true});
    player.addEventListener("error", failed);
    if (signal.aborted) {
      cancelled();
      return;
    }
    try {
      Promise.resolve(player.play()).then(succeed, fail);
    } catch (error) {
      fail(error);
    }
  });
}
